import { useBILogger } from '@wix/fe-essentials/react';
import { useCallback, useMemo } from 'react';
import { getEditorSubType } from '../../../utils';

const EVENT_ID = {
  ADDON_INSTALL_TRY: 105,
  ADDON_INSTALL_SUCCESS: 103,
  ADDON_UNINSTALL_TRY: 106,
  ADDON_UNINSTALL_SUCCESS: 107,
  ADDON_HOVER: 208,
};

export type BaseAddonEventPayload = {
  origin: 'addon_market_card' | 'addon_manage_card';
  editor_type?: string;
  editorType?: string;
};

export type InstallAddonEventPayload = {
  host_app_id: string;
} & BaseAddonEventPayload;

export type UninstallAddonEventPayload = {
  host_app_id: string;
} & BaseAddonEventPayload;

export type HoverAddonEventPayload = {
  origin: 'addon_market_card' | 'addon_manage_card';
  action_context: string;
  editor_type?: string;
  editorType?: string;
};

export const useBi = () => {
  const logger = useBILogger();

  const defaultAddonEvents = useMemo(
    () => ({
      target_type: 'addon',
    }),
    [],
  );

  const addEditorTypeToPayload = (
    payload:
      | BaseAddonEventPayload
      | HoverAddonEventPayload
      | InstallAddonEventPayload
      | UninstallAddonEventPayload,
    evid: number,
  ) => {
    if (evid === EVENT_ID.ADDON_HOVER) {
      payload.editor_type = getEditorSubType();
    } else {
      payload.editorType = getEditorSubType();
    }
  };

  const addonInstallTry = useCallback(
    (payload: InstallAddonEventPayload) => {
      log(payload, EVENT_ID.ADDON_INSTALL_TRY, undefined, 'user');
    },
    [defaultAddonEvents, logger],
  );

  const addonInstallSuccess = useCallback(
    (payload: InstallAddonEventPayload) => {
      log(payload, EVENT_ID.ADDON_INSTALL_SUCCESS, undefined, 'user');
    },
    [defaultAddonEvents, logger],
  );

  const addonUninstallTry = useCallback(
    (payload: UninstallAddonEventPayload) => {
      log(payload, EVENT_ID.ADDON_UNINSTALL_TRY, 'click');
    },
    [defaultAddonEvents, logger],
  );

  const addonUninstallSuccess = useCallback(
    (payload: UninstallAddonEventPayload) => {
      log(payload, EVENT_ID.ADDON_UNINSTALL_SUCCESS, 'click');
    },
    [defaultAddonEvents, logger],
  );

  const addonHover = useCallback(
    (payload: HoverAddonEventPayload) => {
      log(payload, EVENT_ID.ADDON_HOVER, 'click', 'user');
    },
    [defaultAddonEvents, logger],
  );

  const log = (payload: any, evid: number, method?: string, role?: string) => {
    addEditorTypeToPayload(payload, evid);
    logger.log({
      ...payload,
      ...defaultAddonEvents,
      evid,
      method,
      role,
    });
  };

  return {
    addonInstallTry,
    addonInstallSuccess,
    addonUninstallTry,
    addonUninstallSuccess,
    addonHover,
  };
};
